import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '@environments/environment';
import { MAX_PREGENERATION_SIZE } from '@shared/components/image/models';
import { getGravity } from '@shared/components/image/utils';
import { MediaUrlParams } from '@shared/pipes/model';

const CDN_URL = `${environment.CDN.url}/cdn-cgi/image`;
const KEEPEEK_INSTANCES = environment.CDN.keepeekInstances;
const CMS_URL = new URL(environment.API.endpoint.default).origin;

@Pipe({
  name: 'mediaUrl',
  standalone: true,
})
export class MediaUrlPipe implements PipeTransform {
  transform(url: string, params?: MediaUrlParams): string {
    if (!url) return '';
    if (url.startsWith('/assets')) return url;
    const keepeek = KEEPEEK_INSTANCES.find((instance) => url.startsWith(instance.url));
    if (!keepeek && url.startsWith('http')) return url;
    if (params?.noCdnUsage) return `${CMS_URL}${url}`;
    const widthType = typeof params?.width;
    let width = '';
    if (widthType === 'number' && params?.width) {
      width = `,width=${params.width}`;
    } else if (widthType === 'string' && params?.width) {
      const widthString = this.#parseWidth(String(params.width));
      if (widthString.status && widthString.width) {
        width = `,width=${widthString.width}`;
      }
    }
    const height = params?.height ? `,height=${params.height}` : '';
    const gravity = params?.gravity ? getGravity(params?.gravity) : '';
    // Asking no dimension at all makes the CDN return the source file. The only caller sets its
    // params from `afterNextRender`, so the server pass always reaches this without any.
    const size = width || height ? `${width}${height}` : `,width=${MAX_PREGENERATION_SIZE}`;
    const cdnUrl = keepeek ? url.replace(keepeek.url, keepeek.alias) : url;
    return `${CDN_URL}/format=auto,fit=cover${gravity}${size}/${cdnUrl}`;
  }

  #parseWidth(widthStr: string): { status: boolean; width?: string } {
    const match = widthStr.match(/(\d+)px$/);
    if (match) {
      return {
        status: true,
        width: match[1],
      };
    } else {
      return {
        status: false,
      };
    }
  }
}
